import PumpNode from "./PumpNode";
import TankNode from "./TankNode";
import ValveNode from "./ValveNode";
import MotorNode from "./MotorNode";
import JunctionNode from "./JunctionNode";
import ConveyerNode from "./ConveyerNode";
import ChillerNode from "./ChillerNode";
import AHUNode from "./AHUNode";
import BlowerFanNode from "./BlowerFanNode";
import BatteryNode from "./BatteryNode";
import MSBNode from "./MSBNode";
import TransformerNode from "./TransformerNode";
import SwitchgearNode from "./SwitchgearNode";
import SplitACNode from "./SplitACNode";
import HighbayLampNode from "./HighbayLampNode";
import SolarPanelNode from "./SolarPanelNode";
import SolarInverterNode from "./SolarInverterNode";
import VisualizationWidgetNode from "../widgets/VisualizationWidgetNode";

/**
 * Node type registry for React Flow.
 *
 * Keys match the `type` field from COMPONENT_REGISTRY.
 * Every component type now has a dedicated SVG node implementation.
 * GenericNode is kept only as a fallback for future unknown types.
 *
 * `visualizationWidget` – detached floating widget node that renders
 * gauges, mini-graphs, or value displays separately from the parent node.
 */
const nodeTypes = {
  // ── Components with dedicated SVG nodes ──────────────────────────
  pumps: PumpNode,
  tanks: TankNode,
  motor: MotorNode,
  valve: ValveNode,
  conveyer: ConveyerNode,
  chiller: ChillerNode,
  ahu: AHUNode,
  blowerFan: BlowerFanNode,
  battery: BatteryNode,
  msb: MSBNode,
  transformer: TransformerNode,
  switchgear: SwitchgearNode,
  splitACIndoor: SplitACNode,
  highbayLamp: HighbayLampNode,
  solarPanel: SolarPanelNode,
  solarInverter: SolarInverterNode,

  // ── Backward compat for old DB data ("pump" / "tank" / alternative casings) ──
  pump: PumpNode,
  tank: TankNode,
  splitAc: SplitACNode,
  split_ac: SplitACNode,
  solar_panel: SolarPanelNode,
  solar_inverter: SolarInverterNode,

  // ── Junction / pipe intersection ─────────────────────────────────
  junction: JunctionNode,

  // ── Visualization widget (floating instrumentation) ──────────────
  visualizationWidget: VisualizationWidgetNode,
};

export default nodeTypes;
